import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import debounce from 'lodash/debounce';

/**
 * Rascunho automático do cadastro (POST com status "Pendente").
 *
 * `agendar(valores)` salva depois de `atraso` ms sem nova mudança — quem tabula rápido
 * entre campos gera um POST só. `cancelar()` descarta o pendente: o envio final chama
 * antes, senão um rascunho atrasado sobrescreveria o "Cadastrado". `falhou` indica que
 * o último rascunho não foi salvo.
 */
export default function useAutoSave(salvar, atraso = 500) {
  const salvarAtual = useRef(salvar);
  useEffect(() => {
    salvarAtual.current = salvar;
  });

  const [falhou, setFalhou] = useState(false);

  const salvarRascunho = useCallback(async (valores) => {
    try {
      await salvarAtual.current(valores);
      setFalhou(false);
    } catch {
      setFalhou(true);
    }
  }, []);
  const agendar = useMemo(() => debounce(salvarRascunho, atraso), [salvarRascunho, atraso]);

  useEffect(() => () => agendar.cancel(), [agendar]);

  return { agendar, cancelar: agendar.cancel, falhou };
}
